(function() {
  angular.module('cfn').controller('cropSequenceCoreController', [
    '$scope',
    '$rootScope',
    'CoreREST',
    'CropSequence',
    '$http',
    '$timeout',
    '$log',
    '$dialog',
    '$injector',
    '$route',
    'FavoriteService',
    'i18nFilter',
    function(
      $scope,
      $rootScope,
      CoreREST,
      CropSequence,
      $http,
      $timeout,
      $log,
      $dialog,
      $injector,
      $route,
      FavoriteService,
      i18nFilter
    ) {
      var mode = {
        name: 'cropSequence',
        hasActive: true
      };

      var ctrl = this;
      ctrl.getEntityName = function() {
        try {
          return $scope.details.cropSequence.name;
        } catch (e) {
          return '';
        }
      };

      var specialAdd = (mode.specialAdd = []);
      var ele = null;
      ele = {};
      ele.property = 'crops';
      ele.Property = 'Crops';
      specialAdd.push(ele);

      ctrl.addCropsToCropSequence = function() {
        return (elements) => {
          ctrl.callRest('addCropsMultipleById/' + $scope.details.cropSequence.id ) (elements);
        };
      };

      // validation engine
      var vgi = {};
      vgi['active'] = '1';
      vgi['number'] = '1';
      vgi['name'] = '1';
      vgi['crops'] = '1';
      mode.vgi = vgi;

      return coreCommonController(
        'cropSequence',
        ctrl,
        mode,
        $scope,
        $rootScope,
        CoreREST,
        CropSequence,
        $http,
        $timeout,
        $log,
        $dialog,
        $injector,
        $route,
        FavoriteService,
        i18nFilter
      );
    }
  ]);
})();
